import { environment } from 'src/environment';
import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConfigurationService } from 'src/app/core/services/configuration.service';
import { StorageService } from 'src/app/core/services';

@Component({
  selector: 'app-success',
  templateUrl: './success.component.html',
  styleUrls: ['./success.component.scss', '../modal-screens.scss']
})
export class SuccessComponent implements OnInit, OnChanges {
  
  // text that appears before Icon
  @Input() toptext?: string;
  // if the page has button
  @Input() hasActionButton?: boolean = false;
  @Input() buttontext?: string;
  @Input() closeButtonText?: string;
  // if confettie needed.
  @Input() haslottie;
  //text that appears below the icon
  @Input() bottomtext?: string;
  //icon to show , contains icon path
  @Input() icon: string;
  //do something comes from parent
  @Input() actionFuntion?: (args?: any)=> void;
  @Input() redeemWatchBtn;
  @Input() hasHeaderTitle?: boolean; // flag to check whether header title is present in popup(used to set margin on top)
  //lottie options
  lottieOptions={
    path: '/branding/theme/assets/static_assets/ic-success.svg'
  }
  skinName = environment.skinName;
  constructor(public configService: ConfigurationService, private router: Router, private storageService: StorageService) {
  }

  ngOnInit(): void {
    this.storageService.removeLocalStore('discount_code');
    this.storageService.removeLocalStore('discount_type');
    this.storageService.removeLocalStore('operator_voucher');
  }

  ngOnChanges() {
  }

  pageNavigate() {
    this.router.navigateByUrl('/home');
  }
}
